import React, { useMemo } from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import Toolbar from 'devextreme-react/toolbar';
// soluk olabilir silme aşağıda Toolbar için çalışma zamanında oluşturuluyor
import DropDownButton from 'devextreme-react/drop-down-button';
import { useAppState } from "../../contexts/app-state";
import { useAppLocale } from "../../contexts/app-locale";
import {Logo, PageLinks} from "../../components";
import { useScreenSizeClass } from "../../utils/media-query";
import './single-card.scss';

export default React.forwardRef( ({ title, description, children, disabled, page, hideFooter }, ref )=> {
    const { state } = useAppState();
    const { locale, languages, changeLocale } = useAppLocale();
    const screenSizeClass = useScreenSizeClass();

    const toolbarItems = useMemo(() =>[
        {
            location: 'center',
            widget: 'dxDropDownButton',
            options: {
                displayExpr: 'text',
                keyExpr: 'value',
                selectedItemKey: locale,
                width: '100%',
                stylingMode: 'text',
                useSelectMode: true,
                onSelectionChanged: (e) => {
                    if (state.debug) {
                        console.log(e.item);
                    }
                    changeLocale(e.item.value)
                },
                items: languages //.filter(e=>e.value !== locale)
            }
        }
    ], [locale, languages, changeLocale, state.debug])

    return (
        <div className={`app app-bg ${screenSizeClass}`}>
            <div className={'mask gradient'}/>
            <ScrollView ref={ref} height={'100%'} width={'100%'} className={'with-footer single-card'}>
                <div className={'dx-card content'}>
                    <div id='kq-header' className={'header'}>
                        <Logo logo={state.options.logo}/>
                        <div className={'title idp-page-header'}>{title}</div>
                        <div className={'description'}>{description}</div>
                    </div>
                    {children}
                    <br/>
                    {hideFooter !== true && <PageLinks disabled={disabled} active={page} pages={state.pages}/>}
                    {hideFooter !== true && <Toolbar disabled={disabled} items={toolbarItems}/>}
                </div>
            </ScrollView>
        </div>
    );
});


